import {
    AnimationBaseController,
    GameRandom,
    IAnimationControllerConfiguration,
    Inject,
} from '@denishussar/html5-game-engine';
import { ILetterControllerOptions, LetterController } from './LetterController';
import { SendLetterModel } from '../Models/SendLetterModel';
import { ButtonController, IButtonControllerOptions } from './ButtonController';
import { SendLetterLogic } from '../Logic/SendLetterLogic';
import { AnimationContents } from '../../../../../../AnimationContents';
import {
    BackgroundController,
    IBackgroundControllerOptions,
} from './BackgroundController';
import { CursorController } from './CursorController';

export interface IGameScreenControllerOptions {
    onComplete: () => void;
}

export class GameScreenController extends AnimationBaseController {
    $model: SendLetterModel;

    private _width: number = 0;
    private _height: number = 0;

    private _screenWidth: number = 0;
    private _screenHeight: number = 0;
    private _screenScale: number = 1;

    public constructor(
        @Inject private _options: IGameScreenControllerOptions,
        @Inject private _gameLogic: SendLetterLogic,
        @Inject private _random: GameRandom
    ) {
        super('GameScreenController');
    }

    protected getConfiguration(): IAnimationControllerConfiguration {
        return {
            animationContent: AnimationContents.SEND_LETTER_JSON,
            libraryName: 'mini_game_send_a_letter_container',
            childControllers: {
                bgLetter: {
                    view: BackgroundController,
                    instanceName: 'mini_game_send_a_letter.bg_letter',
                    options: <IBackgroundControllerOptions>{
                        onClick: () => {
                            this._gameLogic.print();
                        },
                    },
                    model: this.$model,
                },
                letter: {
                    view: LetterController,
                    instanceName: 'mini_game_send_a_letter.text',
                    options: <ILetterControllerOptions>{},
                    model: this.$model.letter,
                },
                cursor: {
                    view: CursorController,
                    instanceName: 'mini_game_send_a_letter.cursor',
                    model: this.$model.letter,
                },
                sendButton: {
                    view: ButtonController,
                    instanceName: 'mini_game_send_a_letter.button_send',
                    options: <IButtonControllerOptions>{
                        onClick: () => {
                            this._gameLogic.send();
                        },
                        name: 'button_send',
                    },
                    model: this.$model,
                },
            },
            modelEvents: {
                win: () => {
                    this.$queue.get('win').addToQueue(1);
                },
            },
            queue: {
                win: {
                    condition: clock => clock > 0.2,
                    action: () => {
                        this._options.onComplete();
                    },
                },
            },
            // onPointerDown: (e) => {
            //     console.log("container", e);
            //     this._gameLogic.print();
            // }
        };
    }

    protected onInitialize(): void {
        this._width = this.display.width;
        this._height = this.display.height;
    }

    protected onResize(width: number, height: number, scale: number) {
        this._screenWidth = width;
        this._screenHeight = height;
        this._screenScale = scale;

        this.updateScale();
    }

    protected onLandscape(): void {
        this.updateScale();
    }

    protected onPortrait(): void {
        this.updateScale();
    }

    private updateScale(): void {
        this.display.scale.set(
            Math.min(
                this._screenWidth / this._width / this._screenScale,
                this._screenHeight / this._height / this._screenScale
            )
        );
    }
}
